module.exports = __webpack_public_path__ + "4593ccbb710544aeecbaffc98f8a4a8b.MP3";